<div (click)="notifMenu.toggle($event); onOpen()"
     [pTooltip]="tooltip()" tooltipPosition="bottom"
     class="relative rounded-full p-1 text-gray-500 hover:text-gray-700 hover:cursor-pointer">
  <i class="pi pi-bell !text-xl"></i>
  @if (unreadCount() > 0) {
    <span class="absolute top-1 right-1 w-2 h-2 rounded-full bg-[#1D6FD8] ring-2 ring-white"></span>
  }
</div>

<p-popover #notifMenu>
  <div class="w-80">
    <div class="flex items-center justify-between mb-2">
      <span class="font-medium">Notificaciones</span>
      @if (unreadCount() > 0) {
        <button class="text-xs text-blue-600 hover:underline"
                [disabled]="markingAllRead()"
                (click)="markAllAsRead()">Marcar todas como leídas</button>
      }
    </div>
    <p-divider />

    @if (loading()) {
      <div class="flex items-center justify-center py-6 text-gray-400">
        <i class="pi pi-spin pi-spinner"></i>
      </div>
    } @else if (notifications().length === 0) {
      <div class="py-6 text-center text-sm text-gray-500">
        No tienes notificaciones
      </div>
    } @else {
      <ul class="m-[-12px] max-h-80 overflow-auto">
        @for (n of notifications(); track n.id) {
          <li class="px-4 py-2 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
              [class.bg-blue-50]="!n.readAt"
              (click)="onNotificationClick(n)">
            <div class="flex items-start gap-2">
              @if (!n.readAt) {
                <span class="mt-1.5 w-2 h-2 rounded-full bg-blue-500 flex-shrink-0"></span>
              }
              <div class="flex flex-col flex-1 min-w-0">
                <span class="text-sm font-medium text-gray-800">{{ n.title }}</span>
                <span class="text-xs text-gray-600 leading-relaxed">{{ n.message }}</span>
                @if (hasNotifiedEmails(n)) {
                  <button type="button"
                          class="mt-1 self-start text-[11px] text-blue-600 hover:underline"
                          (click)="toggleExpand(n.id, $event)">
                    {{ notifiedEmailsLabel(n) }}
                  </button>
                  @if (isExpanded(n.id)) {
                    <ul class="mt-1 pl-3 border-l border-gray-200 text-[11px] text-gray-600 leading-relaxed break-all">
                      @for (email of n.metadata?.notifiedEmails ?? []; track email) {
                        <li>{{ email }}</li>
                      }
                    </ul>
                  }
                }
                <span class="text-[10px] text-gray-400 mt-1">{{ formatRelativeTime(n.creationDate) }}</span>
              </div>
            </div>
          </li>
        }
      </ul>
    }
  </div>
</p-popover>
